import measurementJobTranslations from "constants/measurementJobTranslations";
import {
  ProductMeasurementJob,
  ProductMeasurementMaterial,
  ProposalProduct,
} from "generated/graphql";

const unitMeasurementLabels = {
  [ProductMeasurementMaterial.TON]: "Ton",
  [ProductMeasurementMaterial.UNIT]: "Unit",
} as const;

export default function getJobSizeUnitLabel(product: ProposalProduct): string {
  const material = product.material;

  if (
    material?.unitPriceProduct &&
    material?.measurementJob?.trim() === ProductMeasurementJob.UNIT
  ) {
    return unitMeasurementLabels[material.measurementMaterial] ?? "Unit";
  }

  return measurementJobTranslations[material?.measurementJob] ?? "";
}
